/**
 * LlmExperimentalBanner — visueller Warnhinweis im Bewertungs-Editor, wenn
 * die LLM-Vorschläge aktiviert sind.
 *
 * Zweck: Berater soll bei jedem Generieren-Klick wissen, dass dies aktuell
 * EXPERIMENTAL ist und nur mit Test-/synthetischen Daten zulässig ist, bis
 * DSFA + DSB-Workshop + AVV abgeschlossen sind.
 *
 * Provider-aware: zeigt dynamisch den aktiven Provider (Claude vs. Mistral)
 * und passt den DSB-Hinweis entsprechend an.
 *
 * WCAG: role="alert" + aria-live="polite" — Screenreader liest den Banner
 * vor, wenn er erscheint, aber nicht aufdringlich.
 */

import { AlertTriangle } from 'lucide-react';
import { getActiveProvider, getActiveProviderLabel } from '../../lib/llm/llmClient';

export function LlmExperimentalBanner() {
  const provider = getActiveProvider();
  const label = getActiveProviderLabel();
  const providerHosting =
    provider === 'anthropic'
      ? 'Anthropic PBC (USA, mit DPA + EU-Standardvertragsklauseln)'
      : provider === 'mistral'
        ? 'Mistral AI SAS (Paris, EU)'
        : 'kein Provider konfiguriert';

  return (
    <div
      role="alert"
      aria-live="polite"
      className="mb-6 flex items-start gap-3 rounded-sm border border-red-300 bg-red-50 px-4 py-3"
    >
      <AlertTriangle size={16} className="mt-0.5 flex-shrink-0 text-red-700" aria-hidden="true" />
      <div className="flex-1">
        <p className="font-sans text-xs font-medium uppercase tracking-widest text-red-800">
          Experimental · KI-Vorschläge ({label})
        </p>
        <p className="mt-1 font-serif text-sm leading-relaxed text-red-900">
          Die KI-Vorschläge werden an {providerHosting} übertragen. Vor jedem Call werden Klarnamen,
          Adresse, Geburtsdatum und Aktenzeichen entfernt (Pseudonymisierung). Dennoch: aktuell
          ausschließlich für interne Tests mit synthetischen oder Test-Mandanten freigegeben. Bei
          echten Mandantendaten erst nach Abschluss der DSFA, dem DSB-Workshop und dem AVV mit dem
          LLM-Anbieter verwenden.
        </p>
      </div>
    </div>
  );
}
